import { CircularProgress } from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { ACCOUNTS_CONNECT_TOKEN, ACCOUNTS_ENV } from 'settings';
import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';

let ConnectEduzz = React.lazy(() => import('@eduzz/connect'));

export const Connect = () => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [loadingBetaModules] = useObservable(() => eduzzAccountsService.getLoadingBetaModules(), []);
  const isBetaNewConnect = eduzzAccountsService.verifyUserHasBetaModule('new_connect');
  if (!user) return null;
  if (loadingBetaModules) return <CircularProgress />;
  if (!isBetaNewConnect && !user.is_support) return <Redirect to='/producer/connect' />;
  return (
    <Fade in timeout={500}>
      <div>
        <style>
          {`
            #main-content {
              max-width: calc(944px + 3rem);
              margin: 0 auto;
            }
          `}
        </style>
        <TopPage title='Connect' />

        <Grid container>
          <Grid item xs={12}>
            <React.Suspense fallback={<CircularProgress />}>
              <ConnectEduzz application='orbita' env={ACCOUNTS_ENV} accounts_partner={ACCOUNTS_CONNECT_TOKEN} user_id={user.id}></ConnectEduzz>
            </React.Suspense>
          </Grid>
        </Grid>
      </div>
    </Fade>
  );
};
